<template>
  <div id="ap">
    <Header/>
    <!-- <section class="container"> -->
    <div class="concept">
      <p>
        LIFE is self-replicating and self-supporting smart contract on Ethereum. They earn their energy (ether) by selling NFTs themselves in order to survive. When they make enough energy, they reproduce themselves and leave offspring. This is the world first full on-chain evolving artificial life on Ethereum.
      </p>
      <p style="text-align: center; color: red">
        (This is the alpha version on Ethereum testnet Rinkeby).
      </p>
    </div>

    <div class="display-btn">
      <button class="btn btn-primary" @click="view1">■</button>
      <button class="btn btn-primary" @click="view2">⊥</button>
    </div>

    <div class="content">
      <component :is="currentView"></component>
    </div>

    <!-- <list/> -->
    <Footer/>
    <!-- </section> -->
  </div>
</template>

<script>
import TreeD3 from "./TreeD3.vue"
import List from "./List.vue"
import Header from "./Header.vue"
import Footer from "./Footer.vue"
import Web3Util from "../web3_util.js"

export default {
  name: 'ap',
  components: {
   // Firestore,
   TreeD3,
   List,
   Header,
   Footer
  },
  data () {
    return {
      //(2)表示するコンポーネント名を指定します。
      // currentView: 'TreeD3'
      currentView: 'List'

    }
  },
  // mounted: async function() {
  //   await Web3Util.load();
  // },
  methods: {
    //(3)ボタンクリックで表示するコンポーネントを切り替える
    view1() {
      this.currentView = "List"
    },
    view2() {
      this.currentView = "TreeD3"
    }
  }
}

</script>

<style>
.display-btn {
  /* text-align: right; */
  /* padding: 0px, 0px; */
}

.concept {
  text-align: left;
  padding: 10% 15%;
  font-size: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue